(function () {
  var popup = document.querySelector("[data-rebuy-atc-popup]");
  if (!popup) return;

  var track = popup.querySelector("[data-rebuy-atc-track]");
  var prev = popup.querySelector("[data-rebuy-atc-prev]");
  var next = popup.querySelector("[data-rebuy-atc-next]");
  var closeButtons = popup.querySelectorAll("[data-rebuy-atc-close]");

  function openPopup() {
    popup.hidden = false;
    document.body.classList.add("rebuy-atc-popup-open");
  }

  function closePopup() {
    popup.hidden = true;
    document.body.classList.remove("rebuy-atc-popup-open");
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest(
      'form[action*="/cart/add"] button[type="submit"], button[name="add"], .product-form__submit, [data-add-to-cart]'
    );

    if (trigger && !trigger.closest(".rebuy-atc-popup")) {
      setTimeout(openPopup, 700);
    }

    if (event.target.closest("[data-rebuy-atc-close]")) {
      closePopup();
    }
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target.closest("[data-rebuy-atc-add]");
      if (!form) return;

      event.preventDefault();

      var button = form.querySelector("button[type='submit']");
      var originalText = button ? button.textContent : "";

      if (button) {
        button.disabled = true;
        button.textContent = "Adding...";
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Add to cart failed");
          return response.json();
        })
        .then(function () {
          if (button) button.textContent = "Added";

          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("cart:updated"));
          document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        })
        .catch(function () {
          if (button) button.textContent = "Try Again";
        })
        .finally(function () {
          setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          }, 1200);
        });
    },
    true
  );

  if (prev && track) {
    prev.addEventListener("click", function () {
      track.scrollBy({
        left: -320,
        behavior: "smooth"
      });
    });
  }

  if (next && track) {
    next.addEventListener("click", function () {
      track.scrollBy({
        left: 320,
        behavior: "smooth"
      });
    });
  }

  closeButtons.forEach(function (button) {
    button.addEventListener("click", closePopup);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closePopup();
    }
  });
})();